import React from "react";

export const Footer = (props) => {
	const year = new Date().getFullYear();

	const getCopyrightYearText = (corp_year, copy_year) => {
		let text = corp_year !== undefined ? corp_year : "";
		if (copy_year !== undefined) {
			text += (corp_year !== undefined ? "-" : "") + (copy_year === "auto" ? year : copy_year);
		}
		return text;
	};

	const printCopyrightText = (props) => {
		let text = getCopyrightYearText(props.corp_year, props.copy_year);
		let copy_text = "Todos los Derechos Reservados";
		if (props.corporation !== undefined) {
			text += " " + props.corporation;
		}
		if (props.copy_text !== undefined) {
			copy_text = props.copy_text;
		}
		text += ". " + copy_text;
		return text;
	};

	return (
		<footer className="footer">
			<small>Copyright &copy; {printCopyrightText(props)}</small>
		</footer>
	);
};
